import {
  Button,
  Checkbox,
  Divider,
  Dropdown,
  Form,
  Header,
  Input,
  Accordion,
  Icon,
  Label,
  List,
} from "semantic-ui-react";
import moment from "moment";
import { statusList } from "./statusList";
import { AuthContext } from "../AuthContext";
import { useContext, useState } from "react";
import DatePicker from "react-datepicker";

const ViewEditJob = (props) => {
  const {
    selectedJob,
    handleChangeFieldString,
    setSelectedJob,
    themeColor,
    setEditDisabled,
    servicesList,
    getConfirmedCompleted,
    handleUpdateJob,
    updating,
  } = props;
  const { loginContext } = useContext(AuthContext);
  const [activeMenu, setActiveMenu] = useState(false);
  const isCSR = loginContext.role === "CSR";
  const isAttorney = loginContext.role === "Attorney";
  const isVideographer = loginContext.role === "Videographer";

  const handleChangeStartDate = (start) => {
    setEditDisabled(false);
    const obj = { ...selectedJob };
    Object.assign(obj, { start });
    setSelectedJob(obj);
  };
  const handleChangeEndDate = (end) => {
    setEditDisabled(false);
    const obj = { ...selectedJob };
    Object.assign(obj, { end });
    setSelectedJob(obj);
  };
  const timeZoneOptions = [
    { key: "PST", value: "America/Los_Angeles", text: "Pacific (PST)" },
    { key: "MST", value: "America/Denver", text: "Mountain (MST)" },
    { key: "CST", value: "America/Chicago", text: "Central (CST)" },
    { key: "EST", value: "America/New_York", text: "Eastern (EST)" },
    { key: "UTC", value: "UTC", text: "UTC" },
  ];

  const noRateMessage =
    "No Rate Set - Enter a price for this service in your Profile.";
  return (
    <div>
      {selectedJob.status === "Requested" && isCSR && (
        <div
          style={{ display: "flex", justifyContent: "center", margin: "20px" }}
        >
          <Button.Group className="animate__animated animate__tada">
            <Button
              disabled={updating}
              size="large"
              content="Confirm?"
              color="blue"
              onClick={() => handleUpdateJob("Confirmed")}
            />
            <Button.Or />
            <Button
              disabled={updating}
              size="large"
              content="Decline?"
              color="red"
              onClick={() => handleUpdateJob("Declined")}
            />
          </Button.Group>
        </div>
      )}
      <Form size="large">
        <Form.Group widths={"equal"}>
          <Form.Field>
            <label>Date Created:</label>
            <Header
              style={{ margin: "0px" }}
              content={moment(selectedJob.createdAt).format("LLL")}
            />
          </Form.Field>
          <Form.Field>
            <label>Requested By:</label>
            <Header
              style={{ margin: "0px" }}
              content={selectedJob.requesterName}
            />
          </Form.Field>
          <Form.Field>
            <label>CSR:</label>
            <Header
              style={{ margin: "0px" }}
              content={selectedJob.reporterName}
            />
          </Form.Field>
        </Form.Group>

        <Form.Group widths={"equal"}>
          <Form.Input
            required
            id="name"
            label="Case Name"
            placeholder="Enter a name for this job"
            value={selectedJob.name || ""}
            onChange={handleChangeFieldString}
          />
          <Form.Input
            required
            id="caseType"
            label="Case Type"
            placeholder="Enter the type of case"
            value={selectedJob.caseType || ""}
            onChange={handleChangeFieldString}
          />
        </Form.Group>
        <Form.Group widths={"equal"}>
          <Form.Input
            required
            id="witnessName"
            label="Witness Name"
            placeholder="Enter a name for the witness"
            value={selectedJob.witnessName || ""}
            onChange={handleChangeFieldString}
          />
          <Form.Input
            required
            id="witnessType"
            label="Witness Type"
            placeholder="e.g. Expert, Doctor, etc."
            value={selectedJob.witnessType || ""}
            onChange={handleChangeFieldString}
          />
        </Form.Group>

        <Form.Group widths={"equal"}>
          <Form.Field id="startDateField" required>
            <label>Start Date / Time:</label>
            <DatePicker
              placeholderText="Select a Date and Time"
              id="start"
              selected={selectedJob.start || ""}
              dateFormat="MMMM d, yyyy h:mm aa"
              showTimeSelect
              timeIntervals={30}
              minDate={new Date()}
              onChange={handleChangeStartDate}
              fixedHeight
            />
          </Form.Field>

          <Form.Field id="endDateField" required>
            <label>End Date / Time:</label>
            <DatePicker
              placeholderText="Select a Date and Time"
              id="end"
              selected={selectedJob.end || ""}
              dateFormat="MMMM d, yyyy h:mm aa"
              showTimeSelect
              timeIntervals={30}
              minDate={selectedJob.start || new Date()}
              onChange={handleChangeEndDate}
              fixedHeight
            />
          </Form.Field>
        </Form.Group>
        <Form.Group widths={"equal"}>
          <Form.Select
            id="timeZone"
            require
            options={timeZoneOptions}
            value={selectedJob.timeZone}
            selection
            label="Time Zone"
            placeholder="Select Time Zone"
            onChange={handleChangeFieldString}
          />
          <Form.Input
            required
            id="location"
            label="Job Location"
            placeholder="Enter location's physical address, or 'Remote'"
            value={selectedJob.location || ""}
            onChange={handleChangeFieldString}
          />
        </Form.Group>
        <Form.Group widths={"equal"}>
          <Form.Input
            id="claimNumber"
            label="Claim Number"
            placeholder="Enter the claim number (if insurance related)"
            value={selectedJob.claimNumber || ""}
            onChange={handleChangeFieldString}
          />
          <Form.Input
            id="insuranceCarrier"
            label="Insurance Carrier"
            placeholder="Enter the Insurance Carrier (if insurance related)"
            value={selectedJob.insuranceCarrier || ""}
            onChange={handleChangeFieldString}
          />
        </Form.Group>
        <Form.Input
          id="clientMatterNumber"
          label="Client Matter #"
          placeholder="Enter Client Matter #"
          value={selectedJob.clientMatterNumber || ""}
          onChange={handleChangeFieldString}
        />

        <Divider horizontal section>
          Optional Services
        </Divider>
        {/* <Form.Checkbox
            id="requestedRealtime"
            label="Realtime Transcript"
            checked={selectedJob.requestedRealtime}
            onChange={handleChangeFieldString}
          /> */}
        <Form.Checkbox
          id="requestedRemote"
          label="Remote Services (Video, Realtime, etc.)"
          checked={selectedJob.requestedRemote}
          onChange={handleChangeFieldString}
        />
        <Form.Checkbox
          id="requestedVideographer"
          label="Videographer"
          checked={selectedJob.requestedVideographer}
          onChange={handleChangeFieldString}
        />
        <Form.Checkbox
          id="requestedInterpreter"
          label="Interpreter"
          checked={selectedJob.requestedInterpreter}
          onChange={handleChangeFieldString}
        />
        {selectedJob.requestedInterpreter && (
          <Form.Input
            id="interpreterLanguage"
            label="Interpreter Language"
            placeholder="e.g. English, Spanish, etc."
            value={selectedJob.interpreterLanguage || ""}
            onChange={handleChangeFieldString}
          />
        )}
        <Form.TextArea
          id="additionalRequests"
          label="Additional Requests"
          placeholder="Enter any special requests for services, deliverables, dates, etc."
          value={selectedJob.additionalRequests || ""}
          onChange={handleChangeFieldString}
        />

        <Form.Field>
          <label>Status:</label>
          <Dropdown
            upward
            id="status"
            disabled={isAttorney}
            value={selectedJob.status}
            selection
            options={statusList}
            onChange={handleChangeFieldString}
          />
        </Form.Field>

        {!isAttorney && getConfirmedCompleted() && (
          <Accordion>
            <Accordion.Title
              active={activeMenu}
              onClick={() => setActiveMenu(!activeMenu)}
            >
              <Label
                style={{
                  color: "#FFFFFF",
                  backgroundColor: themeColor,
                  borderColor: themeColor,
                  width: "100%",
                }}
                basic
                content="Services Rendered"
                size="big"
                icon="dropdown"
                iconPosition="right"
              />
            </Accordion.Title>
            <Accordion.Content active={activeMenu}>
              <div>
                <Divider section horizontal>
                  SERVICES
                </Divider>
                <Form.Field>
                  <p style={{ color: "#7D7D7D", textAlign: "center" }}>
                    Add the values for all applicable services for this job.
                    e.g. number of pages, number of hours, or check the box for
                    any fixed price service.
                  </p>
                </Form.Field>
                <Form.Field>
                  <label>Initial Appearance Fee</label>
                  <Checkbox
                    disabled={!servicesList.appearanceFee}
                    id="bill_appearanceFee"
                    label="Include"
                    checked={selectedJob.bill_appearanceFee}
                    onChange={handleChangeFieldString}
                  />
                  <Input
                    disabled
                    id="initialAppearanceFee"
                    onChange={handleChangeFieldString}
                    placeholder="Enter Number of Billable Pages"
                    value={servicesList.appearanceFee}
                    action={<Button content="Fixed" disabled />}
                  />
                </Form.Field>

                <Form.Field>
                  <label>Hours Worked</label>
                  <Input
                    disabled={!servicesList.hourlyRate}
                    id="bill_hourlyRate"
                    value={selectedJob.bill_hourlyRate}
                    onChange={handleChangeFieldString}
                    placeholder={
                      servicesList.hourlyRate
                        ? "Enter number of hours, e.g. 8"
                        : noRateMessage
                    }
                    action={
                      <Button
                        content={`$${servicesList.hourlyRate} Per Hour`}
                        disabled
                      />
                    }
                  />
                </Form.Field>

                <Form.Field>
                  <label>Take Down / No Write</label>
                  <Checkbox
                    disabled={!servicesList.takeDownNoWrite}
                    id="bill_takeDownNoWrite"
                    label="Include"
                    checked={selectedJob.bill_takeDownNoWrite}
                    onChange={handleChangeFieldString}
                  />
                  <Input
                    disabled
                    id="initialAppearanceFee"
                    onChange={handleChangeFieldString}
                    placeholder={noRateMessage}
                    value={servicesList.takeDownNoWrite}
                    action={<Button content="Fixed" disabled />}
                  />
                </Form.Field>

                <Form.Field>
                  <label>Wait Time - Hours</label>
                  <Input
                    disabled={!servicesList.waitTime}
                    id="bill_waitTime"
                    value={selectedJob.bill_waitTime}
                    onChange={handleChangeFieldString}
                    placeholder={
                      servicesList.waitTime
                        ? "Enter number of hours, e.g. 2"
                        : noRateMessage
                    }
                    action={
                      <Button
                        content={`$${servicesList.waitTime || "0.00"} Per Hour`}
                        disabled
                      />
                    }
                  />
                </Form.Field>

                <Form.Field>
                  <label>After Hours / Weekend - Hours</label>
                  <Input
                    disabled={!servicesList.afterHours}
                    id="bill_afterHours"
                    value={selectedJob.bill_afterHours}
                    onChange={handleChangeFieldString}
                    placeholder={
                      servicesList.afterHours
                        ? "Enter number of hours, e.g. 4"
                        : noRateMessage
                    }
                    action={
                      <Button
                        content={`$${
                          servicesList.afterHours || "0.00"
                        } Per Hour`}
                        disabled
                      />
                    }
                  />
                </Form.Field>

                <Form.Field>
                  <label>Cancellation Fee</label>
                  <Checkbox
                    disabled={!servicesList.cancellationFee}
                    id="bill_cancellationFee"
                    label="Include"
                    checked={selectedJob.bill_cancellationFee}
                    onChange={handleChangeFieldString}
                  />
                  <Input
                    disabled
                    id="cancellationFee"
                    onChange={handleChangeFieldString}
                    placeholder={noRateMessage}
                    value={servicesList.cancellationFee}
                    action={<Button content="Fixed" disabled />}
                  />
                </Form.Field>

                <Divider section horizontal>
                  Transcript & Exhibits
                </Divider>

                <Form.Field>
                  <label>Original Transcript (1 Copy) - Number of Pages</label>
                  <Input
                    disabled={!servicesList.originalTranscriptPlusOneCopy}
                    id="bill_originalTranscriptPlusOneCopy"
                    value={selectedJob.bill_originalTranscriptPlusOneCopy}
                    onChange={handleChangeFieldString}
                    placeholder={
                      servicesList.originalTranscriptPlusOneCopy
                        ? "Enter number of pages, e.g. 300"
                        : noRateMessage
                    }
                    action={
                      <Button
                        content={`$${
                          servicesList.originalTranscriptPlusOneCopy || "0.00"
                        } Per Page`}
                        disabled
                      />
                    }
                  />
                </Form.Field>

                <Form.Field>
                  <label>Index Fee - Number of Pages</label>
                  <Input
                    disabled={!servicesList.indexFee}
                    id="bill_indexFee"
                    value={selectedJob.bill_indexFee}
                    onChange={handleChangeFieldString}
                    placeholder={
                      servicesList.indexFee
                        ? "Enter number of pages, e.g. 300"
                        : noRateMessage
                    }
                    action={
                      <Button
                        content={`$${servicesList.indexFee || "0.00"} Per Page`}
                        disabled
                      />
                    }
                  />
                </Form.Field>

                <Form.Field>
                  <label>Minimum Original Transcript Fee</label>
                  <Checkbox
                    disabled={!servicesList.minimumOriginalTranscriptFee}
                    id="bill_minimumOriginalTranscriptFee"
                    label="Include"
                    checked={selectedJob.bill_minimumOriginalTranscriptFee}
                    onChange={handleChangeFieldString}
                  />
                  <Input
                    disabled
                    id="minimumOriginalTranscriptFee"
                    onChange={handleChangeFieldString}
                    placeholder={noRateMessage}
                    value={servicesList.minimumOriginalTranscriptFee}
                    action={<Button content="Fixed" disabled />}
                  />
                </Form.Field>

                <Form.Field>
                  <label>Additional Copy - Number of Pages</label>
                  <Input
                    disabled={!servicesList.copyTranscript}
                    id="bill_copyTranscript"
                    value={selectedJob.bill_copyTranscript}
                    onChange={handleChangeFieldString}
                    placeholder={
                      servicesList.copyTranscript
                        ? "Enter number of pages, e.g. 300"
                        : noRateMessage
                    }
                    action={
                      <Button
                        content={`$${
                          servicesList.copyTranscript || "0.00"
                        } Per Page`}
                        disabled
                      />
                    }
                  />
                </Form.Field>

                <Form.Field>
                  <label>Medical/Expert - Number of Pages</label>
                  <Input
                    disabled={!servicesList.medicalExpert}
                    id="bill_medicalExpert"
                    value={selectedJob.bill_medicalExpert}
                    onChange={handleChangeFieldString}
                    placeholder={
                      servicesList.medicalExpert
                        ? "Enter number of pages, e.g. 300"
                        : noRateMessage
                    }
                    action={
                      <Button
                        content={`$${
                          servicesList.medicalExpert || "0.00"
                        } Per Page`}
                        disabled
                      />
                    }
                  />
                </Form.Field>

                <Form.Field>
                  <label>Hearings/Arbitrations - Number of Pages</label>
                  <Input
                    disabled={!servicesList.hearingsArbitrations}
                    id="bill_hearingsArbitrations"
                    value={selectedJob.bill_hearingsArbitrations}
                    onChange={handleChangeFieldString}
                    placeholder={
                      servicesList.hearingsArbitrations
                        ? "Enter number of pages, e.g. 300"
                        : noRateMessage
                    }
                    action={
                      <Button
                        content={`$${
                          servicesList.hearingsArbitrations || "0.00"
                        } Per Page`}
                        disabled
                      />
                    }
                  />
                </Form.Field>

                <Form.Field>
                  <label>Trials - Number of Pages</label>
                  <Input
                    disabled={!servicesList.trials}
                    id="bill_trials"
                    value={selectedJob.bill_trials}
                    onChange={handleChangeFieldString}
                    placeholder={
                      servicesList.trials
                        ? "Enter number of pages, e.g. 300"
                        : noRateMessage
                    }
                    action={
                      <Button
                        content={`$${servicesList.trials || "0.00"} Per Page`}
                        disabled
                      />
                    }
                  />
                </Form.Field>

                <Form.Field>
                  <label>Videotaped - Number of Pages</label>
                  <Input
                    disabled={!servicesList.videoTaped}
                    id="bill_videoTaped"
                    value={selectedJob.bill_videoTaped}
                    onChange={handleChangeFieldString}
                    placeholder={
                      servicesList.videoTaped
                        ? "Enter number of pages, e.g. 300"
                        : noRateMessage
                    }
                    action={
                      <Button
                        content={`$${
                          servicesList.videoTaped || "0.00"
                        } Per Page`}
                        disabled
                      />
                    }
                  />
                </Form.Field>

                <Form.Field>
                  <label>Interpreted - Number of Pages</label>
                  <Input
                    disabled={!servicesList.interpreted}
                    id="bill_interpreted"
                    value={selectedJob.bill_interpreted}
                    onChange={handleChangeFieldString}
                    placeholder={
                      servicesList.interpreted
                        ? "Enter number of pages, e.g. 300"
                        : noRateMessage
                    }
                    action={
                      <Button
                        content={`$${
                          servicesList.interpreted || "0.00"
                        } Per Page`}
                        disabled
                      />
                    }
                  />
                </Form.Field>

                <Form.Field>
                  <label>Audio Transcription - Number of Pages</label>
                  <Input
                    disabled={!servicesList.audioTranscript}
                    id="bill_audioTranscript"
                    value={selectedJob.bill_audioTranscript}
                    onChange={handleChangeFieldString}
                    placeholder={
                      servicesList.audioTranscript
                        ? "Enter number of pages, e.g. 300"
                        : noRateMessage
                    }
                    action={
                      <Button
                        content={`$${
                          servicesList.audioTranscript || "0.00"
                        } Per Page`}
                        disabled
                      />
                    }
                  />
                </Form.Field>

                <Form.Field>
                  <label>Realtime Transcript - Number of Pages</label>
                  <Input
                    disabled={!servicesList.realtime}
                    id="bill_realtime"
                    value={selectedJob.bill_realtime}
                    onChange={handleChangeFieldString}
                    placeholder={
                      servicesList.realtime
                        ? "Enter number of pages, e.g. 300"
                        : noRateMessage
                    }
                    action={
                      <Button
                        content={`$${servicesList.realtime || "0.00"} Per Page`}
                        disabled
                      />
                    }
                  />
                </Form.Field>

                <Form.Field>
                  <label>CART - Number of Pages</label>
                  <Input
                    disabled={!servicesList.cart}
                    id="bill_cart"
                    value={selectedJob.bill_cart}
                    onChange={handleChangeFieldString}
                    placeholder={
                      servicesList.cart
                        ? "Enter number of pages, e.g. 300"
                        : noRateMessage
                    }
                    action={
                      <Button
                        content={`$${servicesList.cart || "0.00"} Per Page`}
                        disabled
                      />
                    }
                  />
                </Form.Field>

                <Form.Field>
                  <label>Rough Draft - Number of Pages</label>
                  <Input
                    disabled={!servicesList.roughDraft}
                    id="bill_roughDraft"
                    value={selectedJob.bill_roughDraft}
                    onChange={handleChangeFieldString}
                    placeholder={
                      servicesList.roughDraft
                        ? "Enter number of pages, e.g. 300"
                        : noRateMessage
                    }
                    action={
                      <Button
                        content={`$${
                          servicesList.roughDraft || "0.00"
                        } Per Page`}
                        disabled
                      />
                    }
                  />
                </Form.Field>

                <Form.Field>
                  <label>ETran - Number of Pages</label>
                  <Input
                    disabled={!servicesList.etran}
                    id="bill_etran"
                    value={selectedJob.bill_etran}
                    onChange={handleChangeFieldString}
                    placeholder={
                      servicesList.etran
                        ? "Enter number of pages, e.g. 300"
                        : noRateMessage
                    }
                    action={
                      <Button
                        content={`$${servicesList.etran || "0.00"} Per Page`}
                        disabled
                      />
                    }
                  />
                </Form.Field>

                <Form.Field>
                  <label>Same Day Expedite - Number of Pages</label>
                  <Input
                    disabled={!servicesList.sameDateExpedite}
                    id="bill_sameDateExpedite"
                    value={selectedJob.bill_sameDateExpedite}
                    onChange={handleChangeFieldString}
                    placeholder={
                      servicesList.sameDateExpedite
                        ? "Enter number of pages, e.g. 300"
                        : noRateMessage
                    }
                    action={
                      <Button
                        content={`$${
                          servicesList.sameDateExpedite || "0.00"
                        } Per Page`}
                        disabled
                      />
                    }
                  />
                </Form.Field>

                <Form.Field>
                  <label>1 Day Expedite - Number of Pages</label>
                  <Input
                    disabled={!servicesList.oneDayExpedite}
                    id="bill_oneDayExpedite"
                    value={selectedJob.bill_oneDayExpedite}
                    onChange={handleChangeFieldString}
                    placeholder={
                      servicesList.oneDayExpedite
                        ? "Enter number of pages, e.g. 300"
                        : noRateMessage
                    }
                    action={
                      <Button
                        content={`$${
                          servicesList.oneDayExpedite || "0.00"
                        } Per Page`}
                        disabled
                      />
                    }
                  />
                </Form.Field>

                <Form.Field>
                  <label>2 Day Expedite - Number of Pages</label>
                  <Input
                    disabled={!servicesList.twoDayExpedite}
                    id="bill_twoDayExpedite"
                    value={selectedJob.bill_twoDayExpedite}
                    onChange={handleChangeFieldString}
                    placeholder={
                      servicesList.twoDayExpedite
                        ? "Enter number of pages, e.g. 300"
                        : noRateMessage
                    }
                    action={
                      <Button
                        content={`$${
                          servicesList.twoDayExpedite || "0.00"
                        } Per Page`}
                        disabled
                      />
                    }
                  />
                </Form.Field>

                <Form.Field>
                  <label>3 Day Expedite - Number of Pages</label>
                  <Input
                    disabled={!servicesList.threeDayExpedite}
                    id="bill_threeDayExpedite"
                    value={selectedJob.bill_threeDayExpedite}
                    onChange={handleChangeFieldString}
                    placeholder={
                      servicesList.threeDayExpedite
                        ? "Enter number of pages, e.g. 300"
                        : noRateMessage
                    }
                    action={
                      <Button
                        content={`$${
                          servicesList.threeDayExpedite || "0.00"
                        } Per Page`}
                        disabled
                      />
                    }
                  />
                </Form.Field>

                <Form.Field>
                  <label>4 Day Expedite - Number of Pages</label>
                  <Input
                    disabled={!servicesList.fourDayExpedite}
                    id="bill_fourDayExpedite"
                    value={selectedJob.bill_fourDayExpedite}
                    onChange={handleChangeFieldString}
                    placeholder={
                      servicesList.fourDayExpedite
                        ? "Enter number of pages, e.g. 300"
                        : noRateMessage
                    }
                    action={
                      <Button
                        content={`$${
                          servicesList.fourDayExpedite || "0.00"
                        } Per Page`}
                        disabled
                      />
                    }
                  />
                </Form.Field>

                <Form.Field>
                  <label>5 Day Expedite - Number of Pages</label>
                  <Input
                    disabled={!servicesList.fiveDayExpedite}
                    id="bill_fiveDayExpedite"
                    value={selectedJob.bill_fiveDayExpedite}
                    onChange={handleChangeFieldString}
                    placeholder={
                      servicesList.fiveDayExpedite
                        ? "Enter number of pages, e.g. 300"
                        : noRateMessage
                    }
                    action={
                      <Button
                        content={`$${
                          servicesList.fiveDayExpedite || "0.00"
                        } Per Page`}
                        disabled
                      />
                    }
                  />
                </Form.Field>

                <Form.Field>
                  <label>6 Day Expedite - Number of Pages</label>
                  <Input
                    disabled={!servicesList.sixDayExpedite}
                    id="bill_sixDayExpedite"
                    value={selectedJob.bill_sixDayExpedite}
                    onChange={handleChangeFieldString}
                    placeholder={
                      servicesList.sixDayExpedite
                        ? "Enter number of pages, e.g. 300"
                        : noRateMessage
                    }
                    action={
                      <Button
                        content={`$${
                          servicesList.sixDayExpedite || "0.00"
                        } Per Page`}
                        disabled
                      />
                    }
                  />
                </Form.Field>

                <Form.Field>
                  <label>7 Day Expedite - Number of Pages</label>
                  <Input
                    disabled={!servicesList.sevenDayExpedite}
                    id="bill_sevenDayExpedite"
                    value={selectedJob.bill_sevenDayExpedite}
                    onChange={handleChangeFieldString}
                    placeholder={
                      servicesList.sevenDayExpedite
                        ? "Enter number of pages, e.g. 300"
                        : noRateMessage
                    }
                    action={
                      <Button
                        content={`$${
                          servicesList.sevenDayExpedite || "0.00"
                        } Per Page`}
                        disabled
                      />
                    }
                  />
                </Form.Field>

                <Form.Field>
                  <label>8 Day Expedite - Number of Pages</label>
                  <Input
                    disabled={!servicesList.eightDayExpedite}
                    id="bill_eightDayExpedite"
                    value={selectedJob.bill_eightDayExpedite}
                    onChange={handleChangeFieldString}
                    placeholder={
                      servicesList.eightDayExpedite
                        ? "Enter number of pages, e.g. 300"
                        : noRateMessage
                    }
                    action={
                      <Button
                        content={`$${
                          servicesList.eightDayExpedite || "0.00"
                        } Per Page`}
                        disabled
                      />
                    }
                  />
                </Form.Field>

                <Form.Field>
                  <label>Exhibit Copy (Black & White) - Number of Pages</label>
                  <Input
                    disabled={!servicesList.exhibitCopyBlackAndWhite}
                    id="bill_exhibitCopyBlackAndWhite"
                    value={selectedJob.bill_exhibitCopyBlackAndWhite}
                    onChange={handleChangeFieldString}
                    placeholder={
                      servicesList.exhibitCopyBlackAndWhite
                        ? "Enter number of pages, e.g. 40"
                        : noRateMessage
                    }
                    action={
                      <Button
                        content={`$${
                          servicesList.exhibitCopyBlackAndWhite || "0.00"
                        } Per Page`}
                        disabled
                      />
                    }
                  />
                </Form.Field>

                <Form.Field>
                  <label>Exhibit Copy (Color) - Number of Pages</label>
                  <Input
                    disabled={!servicesList.exhibitCopyColor}
                    id="bill_exhibitCopyColor"
                    value={selectedJob.bill_exhibitCopyColor}
                    onChange={handleChangeFieldString}
                    placeholder={
                      servicesList.exhibitCopyColor
                        ? "Enter number of pages, e.g. 40"
                        : noRateMessage
                    }
                    action={
                      <Button
                        content={`$${
                          servicesList.exhibitCopyColor || "0.00"
                        } Per Page`}
                        disabled
                      />
                    }
                  />
                </Form.Field>

                <Form.Field>
                  <label>VTC Surcharge - Number of Pages</label>
                  <Input
                    disabled={!servicesList.vtcSurcharge}
                    id="bill_vtcSurcharge"
                    value={selectedJob.bill_vtcSurcharge}
                    onChange={handleChangeFieldString}
                    placeholder={
                      servicesList.vtcSurcharge
                        ? "Enter number of pages, e.g. 40"
                        : noRateMessage
                    }
                    action={
                      <Button
                        content={`$${
                          servicesList.vtcSurcharge || "0.00"
                        } Per Page`}
                        disabled
                      />
                    }
                  />
                </Form.Field>

                <Divider section horizontal>
                  Additional Services
                </Divider>

                <Form.Field>
                  <label>Conference Room - Number of Days</label>
                  <Input
                    disabled={!servicesList.provideConferenceRoom}
                    id="bill_provideConferenceRoom"
                    value={selectedJob.bill_provideConferenceRoom}
                    onChange={handleChangeFieldString}
                    placeholder={
                      servicesList.provideConferenceRoom
                        ? "Enter number of days, e.g. 2"
                        : noRateMessage
                    }
                    action={
                      <Button
                        content={`$${
                          servicesList.provideConferenceRoom || "0.00"
                        } Per Day`}
                        disabled
                      />
                    }
                  />
                </Form.Field>

                <Form.Field>
                  <label>Video Conferencing - Number of Hours</label>
                  <Input
                    disabled={!servicesList.provideVideoConference}
                    id="bill_provideVideoConference"
                    value={selectedJob.bill_provideVideoConference}
                    onChange={handleChangeFieldString}
                    placeholder={
                      servicesList.provideVideoConference
                        ? "Enter number of hours, e.g. 6"
                        : noRateMessage
                    }
                    action={
                      <Button
                        content={`$${
                          servicesList.provideVideoConference || "0.00"
                        } Per Hour`}
                        disabled
                      />
                    }
                  />
                </Form.Field>

                <Form.Field>
                  <label>Remote Services</label>
                  <Checkbox
                    disabled={!servicesList.remoteServices}
                    id="bill_remoteServices"
                    label="Include"
                    checked={selectedJob.bill_remoteServices}
                    onChange={handleChangeFieldString}
                  />
                  <Input
                    disabled
                    id="remoteServices"
                    onChange={handleChangeFieldString}
                    placeholder={noRateMessage}
                    value={servicesList.remoteServices}
                    action={<Button content="Fixed" disabled />}
                  />
                </Form.Field>

                <Form.Field>
                  <label>Additional Laptop - Number of Devices</label>
                  <Input
                    disabled={!servicesList.additionalLaptop}
                    id="bill_additionalLaptop"
                    value={selectedJob.bill_additionalLaptop}
                    onChange={handleChangeFieldString}
                    placeholder={
                      servicesList.additionalLaptop
                        ? "Enter number of devices, e.g. 3"
                        : noRateMessage
                    }
                    action={
                      <Button
                        content={`$${
                          servicesList.additionalLaptop || "0.00"
                        } Per Device`}
                        disabled
                      />
                    }
                  />
                </Form.Field>

                <Form.Field>
                  <label>Additional Tablet - Number of Devices</label>
                  <Input
                    disabled={!servicesList.additionalTablet}
                    id="bill_additionalTablet"
                    value={selectedJob.bill_additionalTablet}
                    onChange={handleChangeFieldString}
                    placeholder={
                      servicesList.additionalTablet
                        ? "Enter number of devices, e.g. 3"
                        : noRateMessage
                    }
                    action={
                      <Button
                        content={`$${
                          servicesList.additionalTablet || "0.00"
                        } Per Device`}
                        disabled
                      />
                    }
                  />
                </Form.Field>

                <Form.Field>
                  <label>Certificate of Non-Appearance</label>
                  <Checkbox
                    disabled={!servicesList.certificateOfNonappearance}
                    id="bill_certificateOfNonappearance"
                    label="Include"
                    checked={selectedJob.bill_certificateOfNonappearance}
                    onChange={handleChangeFieldString}
                  />
                  <Input
                    disabled
                    id="certificateOfNonappearance"
                    onChange={handleChangeFieldString}
                    placeholder={noRateMessage}
                    value={servicesList.courthouseHalfDay}
                    action={<Button content="Fixed" disabled />}
                  />
                </Form.Field>

                <Form.Field>
                  <label>Courthouse - Half Day</label>
                  <Checkbox
                    disabled={!servicesList.courthouseHalfDay}
                    id="bill_courthouseHalfDay"
                    label="Include"
                    checked={selectedJob.bill_courthouseHalfDay}
                    onChange={handleChangeFieldString}
                  />
                  <Input
                    disabled
                    id="courthouseHalfDay"
                    onChange={handleChangeFieldString}
                    placeholder={noRateMessage}
                    value={servicesList.courthouseHalfDay}
                    action={<Button content="Fixed" disabled />}
                  />
                </Form.Field>

                <Form.Field>
                  <label>Courthouse - Full Day</label>
                  <Checkbox
                    disabled={!servicesList.courthouseFullDay}
                    id="bill_courthouseFullDay"
                    label="Include"
                    checked={selectedJob.bill_courthouseFullDay}
                    onChange={handleChangeFieldString}
                  />
                  <Input
                    disabled
                    id="courthouseFullDay"
                    onChange={handleChangeFieldString}
                    placeholder={noRateMessage}
                    value={servicesList.courthouseFullDay}
                    action={<Button content="Fixed" disabled />}
                  />
                </Form.Field>

                <Form.Field>
                  <label>Courthouse Hourly - Number of Hours</label>
                  <Input
                    disabled={!servicesList.courthouseHourly}
                    id="bill_courthouseHourly"
                    value={selectedJob.bill_courthouseHourly}
                    onChange={handleChangeFieldString}
                    placeholder={
                      servicesList.courthouseHourly
                        ? "Enter number of hours, e.g. 6"
                        : noRateMessage
                    }
                    action={
                      <Button
                        content={`$${
                          servicesList.courthouseHourly || "0.00"
                        } Per Hour`}
                        disabled
                      />
                    }
                  />
                </Form.Field>

                <Form.Field>
                  <label>Notary Public - Number of Pages</label>
                  <Input
                    disabled={!servicesList.notaryPublic}
                    id="bill_notaryPublic"
                    value={selectedJob.bill_notaryPublic}
                    onChange={handleChangeFieldString}
                    placeholder={
                      servicesList.notaryPublic
                        ? "Enter number of pages, e.g. 10"
                        : noRateMessage
                    }
                    action={
                      <Button
                        content={`$${
                          servicesList.notaryPublic || "0.00"
                        } Per Page`}
                        disabled
                      />
                    }
                  />
                </Form.Field>

                <Form.Field>
                  <label>Delivery</label>
                  <Checkbox
                    disabled={!servicesList.deliveryHandling}
                    id="bill_deliveryHandling"
                    label="Include"
                    checked={selectedJob.bill_deliveryHandling}
                    onChange={handleChangeFieldString}
                  />
                  <Input
                    disabled
                    id="deliveryHandling"
                    onChange={handleChangeFieldString}
                    placeholder={noRateMessage}
                    value={servicesList.deliveryHandling}
                    action={<Button content="Fixed" disabled />}
                  />
                </Form.Field>

                <Form.Field>
                  <label>Mileage - Number of Miles</label>
                  <Input
                    disabled={!servicesList.mileage}
                    id="bill_mileage"
                    value={selectedJob.bill_mileage}
                    onChange={handleChangeFieldString}
                    placeholder={
                      servicesList.mileage
                        ? "Enter number of miles, e.g. 15"
                        : noRateMessage
                    }
                    action={
                      <Button
                        content={`$${servicesList.mileage || "0.00"} Per Mile`}
                        disabled
                      />
                    }
                  />
                </Form.Field>

                {isVideographer && (
                  <Form.Field>
                    <label>Videographer - Initial Fee</label>
                    <Checkbox
                      disabled={!servicesList.videographerFee}
                      id="bill_videographerFee"
                      label="Include"
                      checked={selectedJob.bill_videographerFee}
                      onChange={handleChangeFieldString}
                    />
                    <Input
                      disabled
                      id="videographerFee"
                      onChange={handleChangeFieldString}
                      placeholder={noRateMessage}
                      value={servicesList.videographerFee}
                      action={<Button content="Fixed" disabled />}
                    />
                  </Form.Field>
                )}

                {isVideographer && (
                  <Form.Field>
                    <label>Videographer - Number of Hours</label>
                    <Input
                      disabled={!servicesList.videographerHourly}
                      id="bill_videographerHourly"
                      value={selectedJob.bill_videographerHourly}
                      onChange={handleChangeFieldString}
                      placeholder={
                        servicesList.videographerHourly
                          ? "Enter number of hours "
                          : noRateMessage
                      }
                      action={
                        <Button
                          content={`$${
                            servicesList.videographerHourly || "0.00"
                          } Per Hour`}
                          disabled
                        />
                      }
                    />
                  </Form.Field>
                )}
              </div>
            </Accordion.Content>
          </Accordion>
        )}
      </Form>
    </div>
  );
};
export default ViewEditJob;
